import { Suspense } from "react";
import ErrorBoundary from "components/ErrorBoundary";
import RoleGuard from "../../Settings/Roles/RoleGuard";
import PageLoadingFallback from "../PageLoadingFallback";

/**
 * Route wrapper with error boundary and loading
 */
const RouteWrapper = ({ children, permissions = [] }) => (
  <ErrorBoundary>
    <Suspense fallback={<PageLoadingFallback />}>
      {permissions.length > 0 ? (
        <RoleGuard
          permissions={permissions}
          fallback={
            <div className="alert alert-danger m-4">
              <h4>Access Denied</h4>
              <p>You don't have permission to access this page.</p>
            </div>
          }
        >
          {children}
        </RoleGuard>
      ) : (
        children
      )}
    </Suspense>
  </ErrorBoundary>
);

export default RouteWrapper;
